import { uiOptions } from '@/config'

export function addModalId(modalId: string) {
  uiOptions().isModalOpen = { ...uiOptions().isModalOpen, [modalId]: false }
}
